// TODO add static float video here
const CarrotModelFallback = () => {
    return (
        <div>
            your browser doesn't support WebGL :(
        </div>
    )
}

export { CarrotModelFallback }